module.exports = __webpack_public_path__ + "static/media/CU.7797b415.svg";